module.exports = __webpack_public_path__ + "static/media/pay0.9585b0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dayup/order/pay0.png
// module id = 800
// module chunks = 0